import { TrendingUp, TrendingDown, Wallet, DollarSign, LineChart, Layers } from "lucide-react";
import { fmtUsd } from "@/lib/api";
import { cn } from "@/lib/utils";

const Metric = ({ label, value, sub, positive, icon: Icon, testid, accent }) => (
  <div
    data-testid={testid}
    className="relative overflow-hidden rounded-lg border border-[var(--border)] bg-[var(--surface)] p-5 transition-colors hover:bg-[var(--surface-hover)]"
  >
    <div className="flex items-center justify-between mb-3">
      <span className="text-[11px] uppercase tracking-[0.15em] text-[var(--text-dim)]">{label}</span>
      <Icon className={cn("h-4 w-4", accent || "text-[var(--text-faint)]")} />
    </div>
    <div className={cn("font-mono text-2xl font-bold tracking-tight",
      positive === undefined ? "text-[var(--text-primary)]" : positive ? "text-[var(--pos)]" : "text-[var(--neg)]")}>
      {value}
    </div>
    {sub !== undefined && (
      <div className={cn("mt-1 text-xs font-mono flex items-center gap-1",
        positive ? "text-[var(--pos)]" : "text-[var(--neg)]")}>
        {positive ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
        {sub}
      </div>
    )}
  </div>
);

export const PortfolioSummary = ({ portfolio }) => {
  if (!portfolio) return null;
  const pnlPositive = portfolio.total_pnl == null ? undefined : portfolio.total_pnl >= 0;
  const realizedPositive = portfolio.realized_pnl == null ? undefined : portfolio.realized_pnl >= 0;
  const live = portfolio.live_mode;
  return (
    <div className="space-y-3" data-testid="portfolio-summary">
      <div className="flex items-center gap-2">
        {live ? (
          <span data-testid="portfolio-live-badge" className="inline-flex items-center gap-1.5 text-[11px] font-bold px-2 py-1 rounded-md bg-[#FF3366]/15 text-[var(--neg)] border border-[#FF3366]/30">
            <span className="h-2 w-2 rounded-full bg-[var(--neg)] animate-pulse" /> CANLI · Gerçek Gate.io Bakiyesi
          </span>
        ) : (
          <span data-testid="portfolio-sim-badge" className="inline-flex items-center gap-1.5 text-[11px] font-bold px-2 py-1 rounded-md bg-[var(--surface-hover)] text-[var(--text-dim)] border border-[var(--border)]">
            SİMÜLASYON · Sanal $10.000
          </span>
        )}
      </div>
      {portfolio.valuation_complete === false && <p data-testid="portfolio-valuation-warning" role="alert" className="text-xs text-[var(--warn)]">Vadeli değerleme eksik; toplam portföy ve K/Z doğrulanamadı. Güncel fiyat bekleniyor.</p>}
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
      <Metric
        testid="portfolio-total-value"
        label="Portföy Değeri"
        value={fmtUsd(portfolio.total_value)}
        icon={LineChart}
        accent="text-[var(--accent)]"
      />
      <Metric
        testid="portfolio-pnl"
        label="Toplam Kar/Zarar"
        value={`${pnlPositive ? "+" : ""}${fmtUsd(portfolio.total_pnl)}`}
        sub={portfolio.total_pnl_pct == null ? undefined : `${pnlPositive ? "+" : ""}${portfolio.total_pnl_pct}%`}
        positive={pnlPositive}
        icon={pnlPositive ? TrendingUp : TrendingDown}
        accent={pnlPositive ? "text-[var(--pos)]" : "text-[var(--neg)]"}
      />
      <Metric
        testid="portfolio-realized"
        label="Realize K/Z"
        value={`${realizedPositive ? "+" : ""}${fmtUsd(portfolio.realized_pnl)}`}
        positive={realizedPositive}
        icon={DollarSign}
        accent={realizedPositive ? "text-[var(--pos)]" : "text-[var(--neg)]"}
      />
      <Metric
        testid="portfolio-cash"
        label="Kullanılabilir USDT"
        value={fmtUsd(portfolio.available_usdt ?? portfolio.cash)}
        icon={Wallet}
        accent="text-[var(--pos)]"
      />
      <Metric
        testid="portfolio-open-positions"
        label="Açık Pozisyon"
        value={portfolio.open_positions_count}
        icon={Layers}
        accent="text-[var(--text-faint)]"
      />
      </div>
    </div>
  );
};
